module.exports = __webpack_public_path__ + "img/Group 16.c407681.webp";